<div class="estimate-profitability-container pt-0" [hidden]="!hideCost">
  <div class="px-1 pb-1">
    <div class="border-top">
      <p-accordion (onOpen)="onTabClose()" (onClose)="onTabClose()" styleClass="upcoming-follow-up estimate-accordion with-right-chevron"
        expandIcon="pi pi-fw pi-chevron-down" collapseIcon="pi pi-fw pi-chevron-right">
        <p-accordionTab [selected]="true">
          <p-header>
            <div class="profitability-header">
              <div class="permanent-header font-bold" id="profitability">
                EXPECTED PROFITABILITY
              </div>
              <div class="collapse-display" [hidden]="!selected" id="profitability-percentage">
                <span [ngClass]="getColorClass(profitabilityData?.totalMargin)">
                  {{formatField(profitabilityData?.totalMargin, 'percentage')}}%
                </span>
                <span class="ml-auto pr-1">
                  <strong [ngClass]="getColorClass(profitabilityData?.totalProfit)">
                    {{formatField(profitabilityData?.totalProfit, 'currency')}}
                  </strong>
                </span>
              </div>
            </div>
          </p-header>

          <!-- Parts -->
          <div class="profitability-content-wrapper">
            <div class="profitability-type">
              <div class="type-icon">
                <i class="fal fa-tools font-gray-45"></i>
              </div>

              <div class="type-text">
                <strong id="profitability-parts">Parts</strong>
                <div class="type-percentage" [ngClass]="getColorClass(profitabilityData?.partMargin)" id="profitability-parts-per">
                  {{formatField(profitabilityData?.partMargin, 'percentage')}}%
                </div>
              </div>
            </div>

            <div class="profitability-info d-flex">
              <div class="profitability-text pr-1">
                <span id="profitability-parts-price">
                  Price
                </span>

                <span id="profitability-parts-cost">
                  Cost
                </span>

                <span id="profitability-parts-profit">
                  Profit
                </span>
              </div>
              <div class="info-icon">
                <i class="fal fa-info-circle text-dark" tooltipPosition="top" pTooltip="After line level discounts"></i>
              </div>

              <div class="info-icon info-cost" style="margin-left: 3px;" *ngIf="profitabilityData?.partCostInfo">
                <i class="fal fa-info-circle text-dark" tooltipPosition="top" [escape]="false"
                  [pTooltip]="profitabilityData?.partCostInfo"></i>
              </div>
            </div>
            <div class="profitability-amount">
              <span [ngClass]="getColorClass(profitabilityData?.partPrice)" id="profitability-parts-price-per">
                {{formatField(profitabilityData?.partPrice, 'currency')}}
              </span>
              <span [ngClass]="getColorClass(profitabilityData?.totalNetPartCost)" id="profitability-parts-cost-per">
                {{formatField(profitabilityData?.totalNetPartCost, 'currency')}}
              </span>
              <span [ngClass]="getColorClass(profitabilityData?.partProfit)" id="profitability-parts-profit-per">
                {{formatField(profitabilityData?.partProfit, 'currency')}}
              </span>
            </div>
          </div>

          <!-- Labor -->
          <div class="profitability-content-wrapper">
            <div class="profitability-type">
              <div class="type-icon">
                <i class="fal fa-user-hard-hat font-gray-45"></i>
              </div>

              <div class="type-text">
                <strong id="profitability-labor">Labor</strong>
                <div class="type-percentage" [ngClass]="getColorClass(profitabilityData?.laborMargin)" id="profitability-labor-per">
                  {{formatField(profitabilityData?.laborMargin, 'percentage')}}%
                </div>
              </div>
            </div>

            <div class="profitability-info d-flex">
              <div class="profitability-text pr-1">

                <span class="flex-start-center position-relative" id="profitability-labor-price">
                  <span>Price</span>
                  <i class="fal fa-info-circle text-dark" tooltipPosition="top"
                    pTooltip="After line level discounts"></i>
                </span>

                <span class="flex-start-center position-relative" id="profitability-labor-cost">
                  <span>Cost</span>
                  <i class="fal fa-info-circle text-dark p-labor-icon" tooltipPosition="top"
                    [pTooltip]="laborCostTooltip" [escape]="false"></i>
                </span>

                <span id="profitability-labor-profit">
                  Profit
                </span>
              </div>
            </div>

            <div class="profitability-amount">
              <span [ngClass]="getColorClass(profitabilityData?.laborPrice)" id="profitability-labor-price-per">
                {{formatField(profitabilityData?.laborPrice, 'currency')}}
              </span>
              <span [ngClass]="getColorClass(profitabilityData?.laborCost)" id="profitability-labor-cost-per">
                {{formatField(profitabilityData?.laborCost, 'currency')}}
              </span>
              <span [ngClass]="getColorClass(profitabilityData?.laborProfit)" id="profitability-labor-profit-per">
                {{formatField(profitabilityData?.laborProfit, 'currency')}}
              </span>
            </div>
          </div>

          <!-- Tires -->
          <div class="profitability-content-wrapper">
            <div class="profitability-type">
              <div class="type-icon">
                <i class="fal fa-tire font-gray-45"></i>
              </div>
              <div class="type-text">
                <strong id="profitability-tire">Tire</strong>
                <div class="type-percentage" [ngClass]="getColorClass(profitabilityData?.tireMargin)" id="profitability-tire-per">
                  {{formatField(profitabilityData?.tireMargin, 'percentage')}}%
                </div>
              </div>
            </div>
            <div class="profitability-info d-flex">
              <div class="profitability-text pr-1">
                <span id="profitability-tire-price">
                  Price
                </span>
                <span id="profitability-tire-cost">
                  Cost
                </span>
                <span id="profitability-tire-profit">
                  Profit
                </span>
              </div>
              <div class="info-icon">
                <i class="fal fa-info-circle text-dark" tooltipPosition="top" pTooltip="After line level discounts"></i>
              </div>

              <div class="info-icon info-cost" *ngIf="profitabilityData?.tireCostInfo">
                <i class="fal fa-info-circle text-dark" tooltipPosition="top" [escape]="false"
                  [pTooltip]="profitabilityData?.tireCostInfo"></i>
              </div>
            </div>
            <div class="profitability-amount">
              <span [ngClass]="getColorClass(profitabilityData?.tirePrice)" id="profitability-tire-price-per">
                {{formatField(profitabilityData?.tirePrice, 'currency')}}
              </span>
              <span [ngClass]="getColorClass(profitabilityData?.totalNetTireCost)" id="profitability-tire-cost-per">
                {{formatField(profitabilityData?.totalNetTireCost, 'currency')}}
              </span>
              <span [ngClass]="getColorClass(profitabilityData?.tireProfit)" id="profitability-tire-profit-per">
                {{formatField(profitabilityData?.tireProfit, 'currency')}}
              </span>
            </div>
          </div>

          <!-- Tires storage -->
          <div *ngIf="isTireStorageEnabled" class="profitability-content-wrapper">
            <div class="profitability-type">
              <div class="type-icon">
                <i class="fal fa-inventory font-gray-45"></i>
              </div>
              <div class="type-text">
                <strong id="profitability-tire-storage">Tire storage</strong>
                <div class="type-percentage" [ngClass]="getColorClass(profitabilityData?.tireStorageMargin)" id="profitability-tire-storage-per">
                  {{formatField(profitabilityData?.tireStorageMargin, 'percentage')}}%
                </div>
              </div>
            </div>
            <div class="profitability-info d-flex">
              <div class="profitability-text pr-1">
                <span id="profitability-tire-storage-price">
                  Price
                </span>
                <span id="profitability-tire-storage-cost">
                  Cost
                </span>
                <span id="profitability-tire-storage-profit">
                  Profit
                </span>
              </div>
              <div class="info-icon">
                <i class="fal fa-info-circle text-dark" tooltipPosition="top" pTooltip="After line level discounts"></i>
              </div>

              <div class="info-icon info-cost" *ngIf="profitabilityData?.tireStorageCostInfo">
                <i class="fal fa-info-circle text-dark" tooltipPosition="top" [escape]="false"
                  [pTooltip]="profitabilityData?.tireStorageCostInfo"></i>
              </div>
            </div>
            <div class="profitability-amount">
              <span [ngClass]="getColorClass(profitabilityData?.tireStoragePrice)" id="profitability-tire-storage-price-per">
                {{formatField(profitabilityData?.tireStoragePrice, 'currency')}}
              </span>
              <span [ngClass]="getColorClass(profitabilityData?.tireStorageCost)" id="profitability-tire-storage-cost-per">
                {{formatField(profitabilityData?.tireStorageCost, 'currency')}}
              </span>
              <span [ngClass]="getColorClass(profitabilityData?.tireStorageProfit)" id="profitability-tire-storage-profit-per">
                {{formatField(profitabilityData?.tireStorageProfit, 'currency')}}
              </span>
            </div>
          </div>

          <!-- Sublet -->
          <div *ngIf="isSubletTrackingEnabled" class="profitability-content-wrapper">
            <div class="profitability-type">
              <div class="type-icon">
                <i class="fal fa-store font-gray-45"></i>
              </div>
              <div class="type-text">
                <strong id="profitability-sublet">Sublet</strong>
                <div class="type-percentage" [ngClass]="getColorClass(profitabilityData?.subletMargin)" id="sublet-per">
                  {{formatField(profitabilityData?.subletMargin, 'percentage')}}%
                </div>
              </div>
            </div>
            <div class="profitability-info d-flex">
              <div class="profitability-text pr-1">
                <span id="profitability-sublet-price">
                  Price
                </span>
                <span id="profitability-sublet-cost">
                  Cost
                </span>
                <span id="profitability-sublet-profit">
                  Profit
                </span>
              </div>
              <div class="info-icon">
                <i class="fal fa-info-circle text-dark" tooltipPosition="top" pTooltip="After line level discounts"></i>
              </div>

              <div class="info-icon info-cost" *ngIf="profitabilityData?.subletCostInfo">
                <i class="fal fa-info-circle text-dark" tooltipPosition="top" [escape]="false"
                  [pTooltip]="profitabilityData?.subletCostInfo"></i>
              </div>
            </div>
            <div class="profitability-amount">
              <span [ngClass]="getColorClass(profitabilityData?.subletPrice)" id="profitability-sublet-price-per">
                {{formatField(profitabilityData?.subletPrice, 'currency')}}
              </span>
              <span [ngClass]="getColorClass(profitabilityData?.subletCost)" id="profitability-sublet-per">
                {{formatField(profitabilityData?.subletCost, 'currency')}}
              </span>
              <span [ngClass]="getColorClass(profitabilityData?.subletProfit)" id="profitability-sublet-profit-per">
                {{formatField(profitabilityData?.subletProfit, 'currency')}}
              </span>
            </div>
          </div>

          <!-- Others -->
          <div class="profitability-content-wrapper">
            <div class="profitability-type">
              <div class="type-icon">
                <i class="fal fa-list font-gray-45"></i>
              </div>
              <div class="type-text">
                <strong id="profitability-other">Other</strong>
                <div class="type-percentage" [ngClass]="getColorClass(profitabilityData?.otherMargin)" id="profitability-other-per">
                  {{formatField(profitabilityData?.otherMargin, 'percentage') }}%
                </div>
              </div>
            </div>
            <div class="profitability-info d-flex">
              <div class="profitability-text pr-1">
                <span id="profitability-other-price">
                  Price
                </span>
                <span id="profitability-other-cost">
                  Cost
                </span>
                <span id="profitability-other-profit">
                  Profit
                </span>
              </div>
              <div class="info-icon">
                <i class="fal fa-info-circle text-dark" tooltipPosition="top" pTooltip="After line level discounts"></i>
              </div>
            </div>
            <div class="profitability-amount">
              <span [ngClass]="getColorClass(profitabilityData?.otherPrice)" id="profitability-other-price-per">
                {{formatField(profitabilityData?.otherPrice, 'currency')}}
              </span>
              <span [ngClass]="getColorClass(profitabilityData?.otherCost)" id="profitability-other-cost-per">
                {{formatField(profitabilityData?.otherCost, 'currency')}}
              </span>
              <span [ngClass]="getColorClass(profitabilityData?.otherProfit)" id="profitability-other-profit-per">
                {{formatField(profitabilityData?.otherProfit, 'currency')}}
              </span>
            </div>
          </div>

          <!-- Fees -->
          <div class="profitability-content-wrapper">
            <div class="profitability-type">
              <div class="type-icon">
                <i class="fal fa-usd-circle font-gray-45"></i>
              </div>

              <div class="type-text">
                <strong id="profitability-service-fee">Service level fees</strong>
                <div class="type-percentage" [ngClass]="getColorClass(profitabilityData?.hazmatFeeMargin)" id="profitability-service-fee-per">
                  {{formatField(profitabilityData?.hazmatFeeMargin, 'percentage')}}%
                </div>
              </div>
            </div>

            <div class="profitability-info d-flex">
              <div class="profitability-text pr-1">
                <span id="profitability-service-fee-price">
                  Price
                </span>
                <span id="profitability-service-fee-cost">
                  Cost
                </span>
                <span id="profitability-service-fee-profit">
                  Profit
                </span>
              </div>
            </div>

            <div class="profitability-amount">
              <span [ngClass]="getColorClass(profitabilityData?.hazmatFeePrice)" id="profitability-service-fee-price-per">
                {{formatField(profitabilityData?.hazmatFeePrice, 'currency')}}
              </span>
              <span [ngClass]="getColorClass(profitabilityData?.hazmatFeeCost)" id="profitability-service-fee-cost-per">
                {{formatField(profitabilityData?.hazmatFeeCost, 'currency')}}
              </span>
              <span [ngClass]="getColorClass(profitabilityData?.hazmatFeeProfit)" id="profitability-service-fee-profit-per">
                {{formatField(profitabilityData?.hazmatFeeProfit, 'currency')}}
              </span>
            </div>
          </div>

          <div class="profitability-footer">
            <div class="profitability-content-wrapper">
              <div class="profitability-type">
                <div class="type-icon">
                  <!-- keep the div -->
                </div>
                <div class="type-text">
                  <span id="profitability-order-discount">Order discount</span>
                  <br />
                  <span id="profitability-shop-supplier-ro-fees">{{isRoLevelFeeEnabled? 'RO fees' : 'Shop supplies'}}</span>
                  <br />
                  <span id="profitability-service-discount">Service discount</span>
                </div>
              </div>
              <div class="profitability-info d-flex">
                <!-- Keep the div -->
              </div>
              <div class="profitability-amount">
                <span [ngClass]="getColorClass(profitabilityData?.totalDiscount)" id="profitability-order-discount-per">
                  {{formatField(profitabilityData?.totalDiscount, 'currency')}}
                </span>
                <span [ngClass]="getColorClass(profitabilityData?.totalTax)" id="profitability-shop-supplier-ro-fees-per">
                  {{formatField(isRoLevelFeeEnabled? profitabilityData?.roFees : profitabilityData?.shopFee,
                  'currency')}}
                </span>
                <span [ngClass]="getColorClass(profitabilityData?.totalTax)" id="profitability-service-discount-per">
                  {{formatField(profitabilityData?.serviceLevelDiscount, 'currency')}}
                </span>
              </div>
            </div>

            <div class="profitability-content-wrapper footer">
              <div class="font-14 flex-between-center py-2 my-2 flex-auto bg-secondary-15 w-100 px-2 bg-gray">
                <div class="profitability-type align-items-center">
                  <div class="type-icon">
                    <i class="fal fa-calculator font-gray-45"></i>
                  </div>
                  <div class="type-text">
                    <strong id="profitability-totalGrossProfit">
                      Total gross profit
                    </strong>
                  </div>
                </div>
                <div class="profitability-amount">
                  <strong class="total" [ngClass]="getColorClass(profitabilityData?.totalProfit)" id="profitability-total-gross-profit-value">
                    {{formatField(profitabilityData?.totalProfit, 'currency')}}
                  </strong>
                </div>
              </div>

              <div *ngIf="this.isCommissionPlanEnabled && this.estimate?.isPaidFull && commisionEarned"
                class="font-14 flex-between-center py-2 flex-auto bg-secondary-15 w-100 px-2 cursor-pointer bg-gray"
                (click)="openCommissionDetailDialog()">
                <div class="profitability-type align-items-center flex-auto">
                  <div class="type-icon">
                    <i class="fas fa-coins font-gray-45"></i>
                  </div>
                  <div class="type-text" id="profitability-commission-earned">
                    <strong>
                      Commission earned
                    </strong>
                  </div>
                </div>
                <div class="profitability-amount">
                  <strong class="total text-green" id="profitability-commission-earned-value">
                    {{formatField(commisionEarned[0]?.totalSumAllDates, 'currency')}}
                  </strong>
                </div>
              </div>
            </div>
          </div>
        </p-accordionTab>
      </p-accordion>
    </div>
  </div>
</div>
